import { Menu, MenuItem } from "@mui/material";
import { Pages } from "../../utils";
import { HashLink } from "react-router-hash-link";

const homeownerDropdownLinks = [
  {
    label: "Why Join",
    to: `${Pages.HOMEOWNER_USER_LANDING}#why-join`, // anchor to be added if not present
  },
  {
    label: "Get Inspired",
    to: Pages.DESIGNER_FILES_PUBLIC,
  },
  {
    label: "Be Informed",
    to: Pages.HOMEOWNER_GUILD_GUIDES,
  },
  {
    label: "Memberships",
    to: Pages.HOMEOWNER_MEMBERSHIP_PRICING,
  },
  {
    label: "Personality Quiz",
    to: Pages.HOMEOWNER_PERSONALITY_QUIZ,
  },
];

export const HomeownerNavMenu = ({
  anchor,
  onClose,
}: {
  anchor: HTMLElement | null;
  onClose: () => void;
}) => {
  return (
    <Menu
      anchorEl={anchor}
      open={Boolean(anchor)}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          width: {
            xs: "100vw",
            sm: "auto",
          },
        },
      }}
      keepMounted
    >
      {homeownerDropdownLinks.map((link) => (
        <MenuItem
          onClick={onClose}
          key={link.label}
          component={HashLink}
          to={link.to}
        >
          {link.label}
        </MenuItem>
      ))}
    </Menu>
  );
}; 
